import { render } from "./Frases.vue?vue&type=template&id=2cba7aa4&scoped=true"
import script from "./Frases.vue?vue&type=script&lang=js"
export * from "./Frases.vue?vue&type=script&lang=js"

import "./Frases.vue?vue&type=style&index=0&id=2cba7aa4&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cba7aa4"]])

export default __exports__